export default __webpack_public_path__ + "static/media/fontLato900_latin2.4b21d625.woff2";